/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAllRead.defs.js'
export * as $defs from './updateAllRead.defs.js'
